import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dynamicDecimal',
})
export class DynamicDecimalPipe implements PipeTransform {

  transform(value: number): string {
    if (value === null || value === undefined) {
      return '-';
    }

    const absValue = Math.abs(value);

    if (absValue < 100) {
      return value.toFixed(2);
    }
    if (absValue >= 100 && absValue < 1000) {
      return value.toFixed(1);
    }
    return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
}
